import { render, staticRenderFns } from "./videoNavigationEditor.vue?vue&type=template&id=ca1d9d26&scoped=true"
import script from "./videoNavigationEditor.vue?vue&type=script&lang=js"
export * from "./videoNavigationEditor.vue?vue&type=script&lang=js"
import style0 from "./videoNavigationEditor.vue?vue&type=style&index=0&id=ca1d9d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1d9d26",
  null
  
)

export default component.exports